/* eslint-disable import/prefer-default-export */
import React from 'react';
import cx from 'classnames';

import { PhotoOverlayProps, ReviewStatus } from '../../../containers/app/documentCapture/uploadDocuments/UploadDocumentsSection/UploadDocumentsSection.types';

import styles from './DocumentImageOverlay.module.scss';

export const DocumentImageOverlay = ({
  handleOverlayClick,
  reviewStatus,
}: PhotoOverlayProps) => {
  const isActionRequired = reviewStatus === ReviewStatus.actionRequired;

  const handleClick = () => (isActionRequired && handleOverlayClick());

  return (
    <div
      className={cx(styles.overlay, {
        [styles.failed]: isActionRequired,
      })}
      onAnimationEnd={(e) => e.stopPropagation()}
      onClick={handleClick}
      role="button"
      tabIndex={0}
    >
    </div>
  );
};
